"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.Container = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _googleApiWrapper = _interopRequireDefault(require("./google-api-wrapper"));
var _mapNew = _interopRequireDefault(require("./map-new"));
var _div;
var Container = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Container, _React$PureComponent);
  function Container() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = Container.prototype;
  _proto.render = function render() {
    var loaded = this.props.loaded;
    if (!loaded) {
      return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
    }
    return /*#__PURE__*/_react["default"].createElement(_mapNew["default"], this.props);
  };
  return Container;
}(_react["default"].PureComponent);
exports.Container = Container;
var _default = (0, _reactRedux.connect)()((0, _googleApiWrapper["default"])({})(Container));
exports["default"] = _default;